var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpireDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    height: 170,
    viewBox: "0 0 170 170",
    width: 170,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m119.256 103.2c-2.762 0-5 2.239-5 5v20.235c0 2.761 2.238 5 5 5s5-2.239 5-5v-20.235c0-2.761-2.238-5-5-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m119.256 138.664c-2.762 0-5 2.239-5 5v.433c0 2.761 2.238 5 5 5s5-2.239 5-5v-.433c0-2.761-2.238-5-5-5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m163.151 144.384-8.111-14.049c.032-.229.07-.457.07-.695v-83.103c0-13.667-11.113-24.787-24.773-24.787h-7.369v-10.376c0-2.761-2.238-5-5-5s-5 2.239-5 5v10.376h-65.823v-10.376c0-2.761-2.238-5-5-5s-5 2.239-5 5v10.376h-7.371c-13.66 0-24.773 11.12-24.773 24.787v82.415c0 13.667 11.113 24.787 24.773 24.787h43.968c.284 1.498.821 2.966 1.618 4.348 2.477 4.29 6.913 6.852 11.867 6.852h64.059c4.953 0 9.39-2.562 11.866-6.852s2.477-9.412 0-13.702zm-148.151-15.433v-82.414c0-8.154 6.627-14.787 14.773-14.787h7.371v13.664c0 2.761 2.238 5 5 5s5-2.239 5-5v-13.664h65.823v13.664c0 2.761 2.238 5 5 5s5-2.239 5-5v-13.664h7.369c8.146 0 14.773 6.633 14.773 14.787v66.6l-13.988-24.229c-2.477-4.29-6.913-6.851-11.866-6.851s-9.391 2.561-11.867 6.851l-31.656 54.831h-45.959c-8.146 0-14.773-6.633-14.773-14.787zm139.491 24.135c-.321.557-1.277 1.852-3.206 1.852h-64.059c-1.93 0-2.886-1.295-3.207-1.852s-.965-2.031 0-3.702l32.029-55.477c.965-1.67 2.563-1.851 3.207-1.851s2.241.181 3.206 1.851l32.029 55.477c.965 1.67.321 3.146 0 3.702z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpireDate);
export default __webpack_public_path__ + "static/media/expire-date.3ebd4a505dc0a03c52c5cd2a2ff17b71.svg";
export { ForwardRef as ReactComponent };